import type { ReactNode } from 'react';
import { Layers3 } from 'lucide-react';

export function AppBrand() {
  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      <Layers3 className="w-5 h-5 text-amber-500" />
      <span className="font-semibold text-sm hidden sm:inline">Novera Labs Admin</span>
    </div>
  );
}

interface AppNavProps {
  left?: ReactNode;
  right?: ReactNode;
}

export default function AppNav({ left, right }: AppNavProps) {
  return (
    <nav className="border-b border-zinc-800 bg-zinc-950/90 backdrop-blur-sm sticky top-0 z-40">
      <div className="container mx-auto px-4 h-14 flex items-center gap-3">
        {left ? <div className="flex items-center gap-3">{left}</div> : null}
        {right ? <div className="ml-auto flex items-center gap-2">{right}</div> : null}
      </div>
    </nav>
  );
}
